import { render, staticRenderFns } from "./im-textarea.vue?vue&type=template&id=581a9ae0"
import script from "./im-textarea.vue?vue&type=script&lang=js"
export * from "./im-textarea.vue?vue&type=script&lang=js"
import style0 from "./im-textarea.vue?vue&type=style&index=0&id=581a9ae0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports